export const EXTERNAL_USER_EMAIL_QUERY_KEY = 'externalUserEmail';
export const IMPERSONATING_QUERY_KEY = 'impersonating';

export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  AGENTS: 'Agents',
  PARTNERS: 'Partners',
  BRAND: 'Brand',
  AIR_TEAM: 'Air Team',
  AGENCY: 'Agency',
  COMMISSIONS: 'Commissions',
  CLIENTS: 'Guest Writer',
  SEO_CONSULTANTS: 'SEO Consultant',
  SUPPORT_STAFF: 'Support Staff',
} as const;

export const USER_ROLES_IDS: Record<UserRoleKey, number> = {
  SUPER_ADMIN: 1,
  AGENTS: 2,
  PARTNERS: 3,
  BRAND: 4,
  AIR_TEAM: 5,
  AGENCY: 6,
  COMMISSIONS: 7,
  CLIENTS: 8,
  SEO_CONSULTANTS: 9,
  SUPPORT_STAFF: 10,
} as const;

export type UserRoleKey = keyof typeof USER_ROLES;
export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
